import { FC, ReactNode, useEffect, useState } from 'react'
import { InputProps as StandardInputProps, Box, IconButton, InputAdornment, TextField, Typography } from '@mui/material'

import { Plus, Refresh, Search } from '@dhl/icons'
import { useDebounce } from '@dhl/utils'

type Props = {
  title?: string
  tableActions?: ReactNode
  onSearch?: (value: string) => void
  onAddRow?: () => void
  onRefresh?: () => void
}

export const DataGridSearchHeader: FC<Props> = ({ title, tableActions, onSearch, onAddRow, onRefresh }) => {
  const [enableSearched, setEnableSearched] = useState<boolean>(false)
  const [search, setSearch] = useState<string>('')
  const debouncedSearch = useDebounce(search, 300)

  useEffect(() => {
    setEnableSearched(true)
  }, [])

  useEffect(() => {
    enableSearched && onSearch?.(debouncedSearch)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearch, onSearch])

  const handleSearchChange: StandardInputProps['onChange'] = (ev) => {
    setSearch(ev.target.value)
  }

  return (
    <Box data-test="datagrid-header" alignItems="center" display="flex" p={2}>
      {title && (
        <Typography data-test="datagrid-title" variant="h4">
          {title}
        </Typography>
      )}
      <Box flexGrow={1} />
      {onSearch && (
        <Box minWidth={180}>
          <TextField
            data-test="datagrid-search"
            placeholder="Zoeken"
            fullWidth
            value={search}
            onChange={handleSearchChange}
            size="small"
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                ),
              },
            }}
          />
        </Box>
      )}
      {onRefresh && (
        <IconButton data-test="datagrid-refresh" size="small" onClick={onRefresh}>
          <Refresh />
        </IconButton>
      )}
      {onAddRow && (
        <IconButton data-test="datagrid-add" size="small" onClick={onAddRow}>
          <Plus />
        </IconButton>
      )}
      {tableActions}
    </Box>
  )
}

export type DataGridSearchHeaderProps = Props
